import { render, staticRenderFns } from "./SupervisionNotificationList.vue?vue&type=template&id=f9371bb0&scoped=true&"
import script from "./SupervisionNotificationList.vue?vue&type=script&lang=js&"
export * from "./SupervisionNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionNotificationList.vue?vue&type=style&index=0&id=f9371bb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9371bb0",
  null
  
)

export default component.exports